import { render, staticRenderFns } from "./detalied.vue?vue&type=template&id=3e5db379&scoped=true&"
import script from "./detalied.vue?vue&type=script&lang=js&"
export * from "./detalied.vue?vue&type=script&lang=js&"
import style0 from "./detalied.vue?vue&type=style&index=0&id=3e5db379&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5db379",
  null
  
)

export default component.exports